var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkin"},[(_vm.isShow)?_c('Error',{attrs:{"show-close":false,"message":_vm.message},on:{"close":function($event){return _vm.close()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }